export class SessionStorage {

    public static setModalAsMinimized() {
        sessionStorage.setItem(this.sessionStorage_modalIsMinimised, "minimized");
    }

    public static setModalAsUnminimized() {
        sessionStorage.setItem(this.sessionStorage_modalIsMinimised, "unminimized");
    }

    public static getIfModalIsMinimized(): boolean {
        // Check whether the modal was minimised (possibly on a previous page view).
        let modalIsMinimised = false;
        const modalIsMinimisedInSessionStorage = sessionStorage.getItem(this.sessionStorage_modalIsMinimised);
        if (modalIsMinimisedInSessionStorage !== undefined) {
            if (modalIsMinimisedInSessionStorage === "minimized") {
                modalIsMinimised = true;
            } else {
                modalIsMinimised = false;
            }
        }
        return modalIsMinimised;
    }

    public static getLiveAlertIDs(): string[] {
        const rawPreviousliveAlertIDs = sessionStorage.getItem(this.sessionStorage_liveAlertIDs);
        if (rawPreviousliveAlertIDs) {
            return rawPreviousliveAlertIDs.split(",");
        } else {
            return [];
        }
    }

    public static setLiveAlertIDs(liveAlertIDs: string[]) {
        sessionStorage.setItem(this.sessionStorage_liveAlertIDs, liveAlertIDs.join(","));
    }

    public static getAlertIDsAlreadySeen(): string[] {
        const rawAlertIDsAlreadySeen = sessionStorage.getItem(this.sessionStorage_alertIDsAlreadySeen);
        if (rawAlertIDsAlreadySeen) {
            return rawAlertIDsAlreadySeen.split(",");
        } else {
            return [];
        }
    }

    public static setAlertIDsAlreadySeen(alertIDs: string[]) {
        sessionStorage.setItem(this.sessionStorage_alertIDsAlreadySeen, alertIDs.join(","));
    }

    public static getNumAjaxRequests(): number {
        const rawNumReqs = sessionStorage.getItem(this.sessionStorage_numAjaxRequests);
        if (rawNumReqs) {
            return parseInt(rawNumReqs, 10);
        } else {
            return 0;
        }
    }

    public static incrementNumAjaxRequests() {
        let numReqs = this.getNumAjaxRequests();
        numReqs = numReqs + 1;
        this.setNumAjaxRequests(numReqs);
    }

    public static decrementNumAjaxRequests() {
        let numReqs = this.getNumAjaxRequests();
        numReqs = numReqs - 1;
        this.setNumAjaxRequests(numReqs);
    }

    private static sessionStorage_modalIsMinimised = "modalIsMinimised";
    private static sessionStorage_liveAlertIDs = "liveAlertIDs";
    private static sessionStorage_alertIDsAlreadySeen = "alertIDsAlreadySeen";
    private static sessionStorage_numAjaxRequests = "numAjaxRequests";

    private static setNumAjaxRequests(numRequests: number) {
        sessionStorage.setItem(this.sessionStorage_numAjaxRequests, numRequests.toString());
    }

}
